import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-theme-chalk/lib/index.css'
import './styles/fonts.css'  // 先加载字体
import './styles/variables.css'
import './styles/animations.css'
import './styles/nprogress.css'
import './styles/mobile.css'
import './permission'
import './style.css'
import i18n from './i18n'
import store from './store'

// 全局配置 passive 事件
import 'default-passive-events'

// 根据本地存储设置语言
const lang = localStorage.getItem('language') || 'zh-CN'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// 根据环境变量决定是否使用 mock
if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_MOCK === 'true') {
  require('./mock')
}

// Import App and core modules
import App from './App.vue'
import router from './router'
import request from './utils/request'

// 将HTTP客户端挂载到Vue原型上
Vue.prototype.$http = request

// 初始化主题类
const theme = localStorage.getItem('theme') || 'dark'
const html = document.documentElement
html.classList.remove('light-theme', 'dark-theme')
html.classList.add(`${theme}-theme`)

// Create Vue instance
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
